import * as React from 'react';

import { useLocation, useNavigate } from 'js/lib/useRouter';

export const useModalState = (initialState = false): [boolean, () => void, () => void, () => void] => {
  const [state, setState] = React.useState(initialState);
  return [state, () => setState(true), () => setState(false), () => setState((_) => !_)];
};

export const useWarningAndRedirectOnPageReload = (entryPoint: string, initialInput?: string, skip?: boolean) => {
  const location = useLocation();
  const navigate = useNavigate();
  const inEntryPoint = location.pathname === entryPoint;

  React.useEffect(() => {
    if (skip) return;
    const handleBeforeUnload = (event: BeforeUnloadEvent) => event.preventDefault();
    if (!inEntryPoint) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [skip, inEntryPoint]);

  React.useEffect(() => {
    if (skip) return;
    if (!initialInput && !inEntryPoint) {
      navigate(entryPoint);
    }
  }, [skip, entryPoint, inEntryPoint, initialInput, location.pathname, navigate]);
};
